import { ContestWithId } from "../interfaces/IContests";
import { findContestSnapshot } from "../utils/firestore";
import { useContestsContext } from "../contexts/ContestsContext";
import { useEffect, useState } from "react";

export const useContest = (contestId: string) => {
  const { contests } = useContestsContext();
  const [contest, setContest] = useState<ContestWithId | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!contestId) {
      setIsLoading(false);
      return;
    }

    // STARA IMPLEMENTACJA - wykomentowana dla łatwego przywrócenia
    // const { contests } = useContestsContext();
    // const fetchData = async () => {
    //   setIsLoading(true);
    //   try {
    //     if (contests && contestId) {
    //       // Pobieramy jedną aplikację
    //       const contest = contests.find((contest) => contest.id === contestId);
    //       setContest(contest ? contest : null);
    //     }
    //   } catch (error) {
    //     console.error("Błąd podczas pobierania aplikacji:", error);
    //   } finally {
    //     setIsLoading(false);
    //   }
    // };
    // fetchData();

// TODO: Sprawdzić czy można wykorz

    // NOWA IMPLEMENTACJA - onSnapshot
    setIsLoading(true);
    const unsubscribe = findContestSnapshot(contestId, (contestData) => {
      setContest(contestData);
      setIsLoading(false);
    });

    // Cleanup - odsubskrybowanie przy unmount lub zmianie contestId
    return () => {
      unsubscribe();
    };
  }, [contestId]);

  return {
    contests,
    contest,
    isLoading,
  };
};
